import * as React from 'react';
import Prism from '@theme-ui/prism';

export function Code(props: { children: string }): React.ReactElement {
  return <Prism {...props} />;
}
